/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { initializeApp } from "firebase/app";
import {
  getAnalytics,
  logEvent as firebaseLogEvent,
  setCurrentScreen as firebaseSetCurrentScreen,
  setUserId as firebaseSetUserId,
  setUserProperties as firebaseSetUserProperties,
  type Analytics
} from "firebase/analytics";
import { reportError } from "../utils/errorUtils";

const firebaseConfig = {
  apiKey: "AIzaSyDbWu8nCGijdlRBZdXOOj-XLaPKELdk1eM",
  authDomain: "manatee-production.firebaseapp.com",
  databaseURL: "https://manatee-production.firebaseio.com",
  projectId: "manatee-production",
  storageBucket: "manatee-production.appspot.com",
  messagingSenderId: "370963521814",
  appId: "1:370963521814:web:6fc72a2b387b8341263037",
  measurementId: "G-LH896V0284"
};

const testUserFamilyIds = new Set([
  5, 9, 24, 29, 14, 22, 46, 170, 206, 207, 275, 276, 284, 362, 394, 547, 549, 855, 1015, 1018, 1028, 1047, 1448, 1676,
  1757, 1799, 1147, 1183, 1217, 1352, 1830, 1850, 1853, 1856, 1871, 1994
]);

const instance: Analytics | null = window.location.href.includes("home.getmanatee.com")
  ? getAnalytics(initializeApp(firebaseConfig))
  : null;

/** Production only, and never for the internal test families. */
function analytics(): Analytics | null {
  if (instance === null) {
    return null;
  }
  const familyId = sessionStorage.getItem("familyId");
  return familyId === null || !testUserFamilyIds.has(parseInt(familyId, 10)) ? instance : null;
}

export function logEvent(event: string, params?: object): void {
  try {
    const target = analytics();
    if (target !== null) {
      firebaseLogEvent(target, event, params as Record<string, unknown> | undefined);
    }
  } catch (error) {
    try {
      reportError(error as Error);
    } catch (reportingError) {
      console.log("Error while reporting error while logging event", reportingError);
    }
  }
}

export function setCurrentScreen(screen: string): void {
  const target = analytics();
  if (target !== null) {
    firebaseSetCurrentScreen(target, screen);
  }
}

export function setUserId(userId: string): void {
  const target = analytics();
  if (target !== null) {
    firebaseSetUserId(target, userId);
  }
}

export function setUserProperties(properties: Record<string, string>): void {
  const target = analytics();
  if (target !== null) {
    firebaseSetUserProperties(target, properties);
  }
}
